<div class="w-full" #pageContainer>
    <div class="w-full grid grid-cols-1">
        <form [formGroup]="searchForm">
            <app-table-filter [searchForm]="searchForm" class="text-primary" (searchTriggered)="handleSearch($event)">
            </app-table-filter>

            <div class="grid grid-cols-1 sm:grid-cols-3">
                <div class="flex justify-start col-span-2">
                    <div class="w-19 ml-2">
                        <mat-form-field class="w-full no-bottom-gap mb-2">
                            <mat-select formControlName="PageSize">
                                <mat-option [value]="10"> 10 </mat-option>
                                <mat-option [value]="20"> 20 </mat-option>
                                <mat-option [value]="50"> 50 </mat-option>
                                <mat-option [value]="100"> 100 </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <app-sort-menu class="mx-2" [columns]="columnSort" [orderDir]="'asc'" [initialOrderKeys]="[]"
                    (apply)="applySort($event)">
                    </app-sort-menu>

                    <button class="btn btn-outline btn-default dt-download mx-2" [matMenuTriggerFor]="downloadMenu">
                        <mat-icon class="text-primary hover:text-white"
                            svgIcon="heroicons_solid:arrow-down-tray"></mat-icon>
                    </button>
                    <mat-menu #downloadMenu="matMenu">
                        <button mat-menu-item (click)="downloadFnExcel()">
                            Excel
                        </button>
                    </mat-menu>
                </div>
                <div class="flex justify-end">
                    <button class="btn btn-outline" (click)="openDialog({ payload: {}, action: 'create' })">
                        + Add
                    </button>
                    <button class="btn btn-primary mx-2" (click)="setPage({ offset: 0 })">
                        Search
                    </button>
                    <button class="btn btn-outline btn-default" (click)="reset()">
                        Reset
                    </button>
                    <button class="btn btn-outline btn-default mx-2 hover:text-white"
                        (click)="setPage({ offset: dt.page.offset })">
                        <mat-icon class="text-primary hover:text-white" svgIcon="heroicons_solid:arrow-path"></mat-icon>
                    </button>
                </div>

                <div class="flex justify-start col-span-2">
                    <span class="self-center font-medium text-gray-400 italic text-md p-2">
                        Sorting by {{ sortInfo }}
                    </span>
                </div>

                <div class="flex justify-end">
                    <span class="self-center font-medium text-primary text-md p-2">
                        {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </span>
                </div>
            </div>
        </form>

        <div class="grid overflow-x-auto">
            <!-- Header -->
            <div class="table-failure-notification-record-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
                matSort matSortDisableClear>
                <div class="border py-8 text-center">
                    No
                </div>

                <div [mat-sort-header]="'fieldLongName'" class="flex justify-center border py-4 my-custom-sort-header">
                    Field
                </div>

                <div [mat-sort-header]="'platformLongName'" class="flex justify-center border py-4">
                    Platform
                </div>

                <div [mat-sort-header]="'wellLongName'" class="flex justify-center border py-4">
                    Well
                </div>

                <div [mat-sort-header]="'stringShortName'" class="flex justify-center border py-4">
                    Well String
                </div>

                <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                    String Indicator
                </div>

                <div [mat-sort-header]="'failureDate'" class="flex border justify-center py-4">
                    Failure Date
                </div>

                <div [mat-sort-header]="'failEquipment'" class="flex border justify-center py-4">
                    Failed Equipment
                </div>

                <div [mat-sort-header]="'problemReported'" class="flex border justify-center py-4">
                    Reported Problem
                </div>

                <div [mat-sort-header]="'riskRanking'" class="flex border justify-center py-4">
                    Risk Ranking
                </div>

                <div [mat-sort-header]="'status'" class="flex border justify-center py-4">
                    Status
                </div>

                <div class="block border text-center py-8">
                    Action
                </div>

            </div>
            <!-- Rows -->
            <ng-container *ngIf="dt.rows.length; else noRecords">
                <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                    <div class="table-failure-notification-record-grid grid items-center border-b"
                        [ngClass]="{'bg-primary-100': i % 2 }">

                        <!-- No -->
                        <div class="py-4 text-center">
                            {{startingIndex + i + 1}}.
                        </div>

                        <!-- Field Long Name -->
                        <div class="flex truncate justify-center">
                            {{ row.fieldLongName }}
                        </div>

                        <!-- Platform Long Name  -->
                        <div class="flex justify-center">
                            {{ row.platformLongName }}
                        </div>

                        <!-- Well Long Name  -->
                        <div class="flex justify-center">
                            {{ row.wellLongName }}
                        </div>

                        <!-- String Short Name  -->
                        <div class="text-center">
                            {{ row.stringShortName }}
                        </div>

                        <!-- String Indicator -->
                        <div class="block text-center">
                            {{ row.stringIndicatorShortName }}
                        </div>

                        <!-- Failure Date -->
                        <div class="block text-center">
                            {{ handleFormatDate(row.failureDate, false) || '-' }}
                        </div>

                        <!-- Failure Equipment -->
                        <div class="block text-center">
                            {{ row.failEquipment || '-' }}
                        </div>

                        <!-- Reported Problem -->
                        <div class="block text-center">
                            {{ row.problemReported || '-' }}
                        </div>

                        <!-- Risk Rangking -->
                        <div class="block text-center mx-2" [ngClass]="{
                                'risk0Badge': row.riskRankingDesc?.toLowerCase() === 'healthy no risk',
                                'risk1Badge': row.riskRankingDesc?.toLowerCase() === 'healthy low risk',
                                'risk2Badge': row.riskRankingDesc?.toLowerCase() === 'healthy medium risk',
                                'risk3Badge': row.riskRankingDesc?.toLowerCase() === 'unhealthy high risk',
                                'risk4Badge': row.riskRankingDesc?.toLowerCase() === 'unhealthy very high risk',
                              }" >
                            {{ row.riskRankingDesc || '-' }}
                        </div>

                        <!-- Status-->
                        <div class="block text-center mx-2" [ngClass]="{
                                    'idleBadge': row.status == status.DRAFT,
                                    'successBadge': row.status == status.APPROVED || row.status == status.CLOSED,
                                    'failedBadge': row.status == status.REJECTED,
                                    'warningBadge': row.status == status.READY
                              }">
                            {{ row.status || '-' }}
                        </div>

                        <!-- Action -->
                        <div class="block text-center">
                            <button class="btn btn-remove-bg"
                                [disabled]="row.status == status.APPROVED || row.status == status.REJECTED">
                                <mat-icon (click)="openDialog({ payload: row, action: 'edit' })" class="text-primary"
                                    [svgIcon]="'heroicons_solid:pencil-square'" matTooltip="Edit"></mat-icon>
                            </button>
                            <button class="btn btn-remove-bg">
                                <mat-icon (click)="openDialog({ payload: row, action: 'view' })" class="text-primary"
                                    [svgIcon]="'heroicons_solid:eye'" matTooltip="View"></mat-icon>
                            </button>

                            <button class="btn btn-remove-bg px-2" [disabled]="row.status != status.DRAFT"
                                (click)="deleteFailureNotification(row.id)">
                                <mat-icon class="text-error" [svgIcon]="'heroicons_outline:trash'" matTooltip="Delete"></mat-icon>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <ng-template #noRecords>
                <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                    There are no records registered!
                </div>
            </ng-template>
        </div>

        <div
            class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
            <div class="content-center px-3">
                {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </div>

                    <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                        [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                        [hidePageSize]="true" [showFirstLastButtons]="true">
                    </mat-paginator>
            </div>

        </div>
    </div>

    <ng-template #closedIcon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
    </ng-template>